import { createFileRoute, Link } from "@tanstack/react-router";
import { Info } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export const Route = createFileRoute("/_authenticated/billing/cancel")({
  head: () => ({
    meta: [
      { title: "決済キャンセル - KAGEM" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: BillingCancelPage,
});

function BillingCancelPage() {
  return (
    <main className="min-h-screen bg-background px-4 py-12">
      <div className="mx-auto max-w-md space-y-6">
        <Card className="border-border/60 shadow-md">
          <CardContent className="flex flex-col items-center gap-5 p-8 text-center">
            <div
              className="flex h-16 w-16 items-center justify-center rounded-full bg-muted animate-scale-in"
              style={{ animationDuration: "0.4s" }}
            >
              <Info className="h-8 w-8 text-muted-foreground" />
            </div>

            <h1 className="text-2xl font-bold tracking-tight">
              決済がキャンセルされました
            </h1>

            <p className="text-sm leading-relaxed text-muted-foreground">
              ご購入はまだ完了していません。
              <br />
              引き続きサービスをお試しいただけます。
            </p>

            <div className="mt-2 flex w-full flex-col gap-2">
              <Button
                asChild
                className="h-11 w-full bg-gradient-brand text-white shadow-lg shadow-brand-primary/30 hover:opacity-95"
              >
                <Link to="/credits-shop">もう一度試す</Link>
              </Button>
              <Button asChild variant="outline" className="h-11 w-full">
                <Link to="/dashboard">ダッシュボードへ</Link>
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* FAQ */}
        <Card className="border-border/60">
          <CardContent className="p-4 sm:p-6">
            <h2 className="mb-2 text-sm font-semibold text-foreground">
              よくある質問
            </h2>
            <Accordion type="single" collapsible className="w-full">
              <AccordionItem value="q-card">
                <AccordionTrigger className="text-left text-sm">
                  クレジットカードが使えなかった場合は？
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                  別のカードや、コンビニ決済のご利用もご検討ください。お困りの場合はお問い合わせください。
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="q-error">
                <AccordionTrigger className="text-left text-sm">
                  決済エラーが出た場合は？
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                  お時間を置いて再度お試しいただくか、別の決済方法をお試しください。
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </CardContent>
        </Card>
      </div>
    </main>
  );
}
